import React, { useContext, Suspense } from 'react';
import { PluginProps } from '../Plugin';
import { AuthContext, Role } from '../../../../../context/AuthProvider';
const LazyMartin = React.lazy(() => import('../../../../martin/martin'));
import { Box } from '@chakra-ui/react';

const GptBlock = (props: PluginProps) => {
  const { content } = props;

  const id = content?.data?.unique_block_id;
  const title = content?.data?.name;

  if (!id) {
    return null;
  }

  return (
    <Box key={id} height="50vh">
      <Suspense fallback={<div>Loading...</div>}>
        <LazyMartin blockId={id} title={title} />
      </Suspense>
    </Box>
  );
};

export default GptBlock;
